<template>
  <AppSection
    id="cron-config-details"
    type="section"
    :title="$t($getConst.pages.cron_config.cron_config_page_title)"
    :is-section-loading="isLoading"
  >
    <AppSection
      id="cron-config-form"
      type="sub-section-1"
      :title="this.cron_name"
      :checkBox="true"
      :checkBoxModel="is_enabled"
      @onChangeCheckBox="onChangeStatus"
      v-if="!isLoading && cronData"
    >
      <form class="mt-4">
        <div id="accordion" class="accordion text-left" role="tablist" v-for="(api, index) in cron_config_apis">
          <b-card no-body class="mb-1 text-left">
            <b-card-header  v-if="cronData.apis.length > 1" header-tag="header" class="p-1 text-left" role="tab" style="text-align: left !important;">
              <b-button block v-b-toggle="'accordion-' + index" variant="outline" class="text-left text-dark"
                        @click="toggleAccordion(index)">
                <b class="mr-2">{{ cron_config_apis[index].name }}</b>
                <div class="float-right">
                  <i v-if="openedCronApi === index" :class="$getConst.icons.chevron_down"></i>
                  <i v-else :class="$getConst.icons.chevron_up"></i>
                </div>
              </b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + index" accordion="CronAccordion" role="tabpanel" :visible="cronData.apis.length === 1">
              <b-card-body style="height: 250px">
                <b-card-text>
                  <b-row>
                    <b-col>
                      <b-form-group :label="$t($getConst.pages.cron_config.start_hour)">
                        <b-form-timepicker :hide-header="true" :hour12="false" :disabled="!is_enabled"
                                           v-model="cron_config_apis[index].start_hour"
                                           locale="en" size="lg"></b-form-timepicker>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group :label="$t($getConst.pages.cron_config.end_hour)">
                        <b-form-timepicker :hide-header="true" :hour12="false" :disabled="!is_enabled"
                                           v-model="cron_config_apis[index].end_hour"
                                           locale="en" size="lg"></b-form-timepicker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div class="text-danger mt-4" v-if="invalidTime !== false">
          {{$t($getConst.pages.cron_config.invalid_start_end_hour)}}
        </div>

        <AppConfirmButtons
          v-if="is_enabled"
          :is-loading="isLoading"
          :first-button="hasPermission(this.$getConst.permissions.writeCronConfig)"
          :cancel-text="$getConst.pages.button.cancel_changes"
          @onSubmit="onSave"
          @onCancel="onReset"
        />
      </form>

    </AppSection>
  </AppSection>
</template>

<script>
  import {getOneCronConfig, updateCronConfig} from "../../../../api/scopes.api";
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";

  export default {
    name: "EditCronConfig",
    components: {AppSpinner, AppConfirmButtons, AppFormFeedback, AppSection},
    props: ['cron_id', 'cron_name'],
    data() {
      return {
        cronData: null,
        cron_config_apis: [],
        is_enabled: '',
        isLoading: false,
        options: [
          {text: 'Enabled', value: true},
          {text: 'Disabled', value: false},
        ],
        context: null,
        invalidTime: false,
        openedCronApi: ''
      }
    },
    methods: {
      getOneCronConfigData() {
        this.isLoading = true;
        getOneCronConfig(this.cron_id).then(
          (response) => {
            this.cronData = Object.assign({}, response.data);
            this.cron_config_apis = Object.assign({}, response.data.apis);
            this.is_enabled = response.data.is_enabled;
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      onChangeStatus(checked) {
        this.is_enabled = checked;
        this.onSave(false);
      },
      onSave(withLoading = true) {
        if (withLoading) {
          this.isLoading = true;
        }
        updateCronConfig(this.cron_id, {
          cron_config_apis: this.cron_config_apis,
          is_enabled: this.is_enabled
        }).then(
          res => {
            if (withLoading){
              this.isLoading = false;
              this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
              this.openedCronApi = '';
            }
          },
          error => {
            this.errorFromServerTreatment(error);
            this.isLoading = false;
            if (withLoading) {
              this.openedCronApi = '';
            }
          }
        )
      },
      errorFromServerTreatment(error) {
        if (error.response.data.code === 422) {
          this.invalidTime = this.extractNumberFromString(Object.keys(error.response.data.error)[0]);
        } else {
          this.handleApiError(error);
        }
        this.$root.$emit('isLoading', false);
        this.isSubmited = false;
      },
      onReset() {
        this.invalidTime = false;
        this.openedCronApi = '';
        this.getOneCronConfigData();
      },
      extractNumberFromString(str) {
        return str.match(/\d+/)[0];
      },
      toggleAccordion(index) {
        this.openedCronApi !== index ? this.openedCronApi = index : this.openedCronApi = '';
      }
    },
    created() {
      this.getOneCronConfigData();
    },
  }
</script>

<style scoped>

</style>
